
import React from 'react';

interface CalculateButtonProps {
  onClick: () => void;
  disabled: boolean;
  isCalculating: boolean;
}

const CalculateButton: React.FC<CalculateButtonProps> = ({
  onClick,
  disabled,
  isCalculating
}) => {
  return (
    <button
      onClick={onClick}
      disabled={disabled}
      className={`w-full py-3 rounded-xl transition-colors duration-200 font-medium flex items-center justify-center ${
        disabled 
          ? 'bg-gray-300 cursor-not-allowed text-gray-500' 
          : 'bg-primary hover:bg-primary-dark text-white'
      }`}
    >
      {isCalculating ? (
        <span className="animate-pulse">Obliczanie...</span>
      ) : (
        'Oblicz ofertę'
      )}
    </button>
  );
};

export default CalculateButton;
